import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { JWTLoginToServer } from "../../services/auth-service/authService";

const SSOLogin = () => {
  const navigate = useNavigate();

useEffect(() => {
  // 1. Extract token from URL hash
  const hash = window.location.hash;
  const token = new URLSearchParams(hash.replace("#", "")).get("token");

  // 2. If no token ? redirect
  if (!token) {
    navigate("/login", { replace: true });
    return;
  }

  // 3. Immediately remove token from URL (important)
  window.history.replaceState(
    null,
    document.title,
    window.location.pathname + window.location.search
  );

  // 4. Call backend
  const [, headers, url] = JWTLoginToServer(token);

  axios
    .post(url, {}, headers)
    .then((res) => {
      const responseData = res.data;

      // 5. Store backend-issued credentials
      const userCredentials = responseData.user_credentials;
      sessionStorage.setItem(
        "userCredentials",
        JSON.stringify(userCredentials)
      );

      // 6. Navigate inside SPA
      navigate("/landing_page", { replace: true });
    })
.catch((err) => {
  console.error("JWT SSO login failed", err);

  let navigated = false;

  // 1. Auto-navigate after 10 seconds if no user action
  const timeoutId = setTimeout(() => {
    if (!navigated) {
      navigated = true;
      navigate("/login", { replace: true });
    }
  }, 10000); // 10 seconds

  // 2. Blocking alert (user action)
  alert("Authorization expired");

  // 3. User clicked OK
  if (!navigated) {
    navigated = true;
    clearTimeout(timeoutId);
    navigate("/login", { replace: true });
  }
});
}, [navigate]);

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      Signing you in�
    </div>
  );
};

export default SSOLogin;
